import { getCookie } from "./cookiesManager";
import { SurveyVariants } from "../types/surveyVariants";

export const isInstanceEmulator = (instanceId: string) => {
  const cachedEmulator = getCookie(SurveyVariants.EMULATOR);
  return Boolean(cachedEmulator?.value && instanceId.includes(cachedEmulator.value));
};
